import React, { useEffect, useState } from 'react';
import NavBar from '@components/navigation/NavBar';
import './ParentPage.css';
import Cookies from 'js-cookie';
import { useStudentSubjectMenuList } from '@hooks/parent.hook';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import { convertToSlug } from '@utils/helpers/convertToSlug';
import { useStore } from 'jotai';
import {
  haveAccountSection,
  haveBackButton,
  haveBottomNavbar,
  haveFullLogo,
  haveLogoutButton,
  haveParentSubjectMenu,
  haveSubjectMenu,
  haveTitle,
  haveTopNavbar,
  resetToDefaultNavbarState,
} from '@atom/navbarAtom';

const ParentPage = () => {
  const [renderParentPage, setRenderParentPage] = useState<boolean>(false);
  const { data: student_subject_menu_list, isLoading } =
    useStudentSubjectMenuList(true);
  const { student_id, subject_id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!student_subject_menu_list || isLoading) return;
    if (!student_subject_menu_list.length) return;
    if (
      !student_subject_menu_list.filter(l => l.is_hybrid).length &&
      subject_id &&
      student_id
    ) {
      navigate(`/parent`);
    }
    if (
      student_subject_menu_list.filter(l => l.is_hybrid).length &&
      !student_id &&
      !subject_id
    ) {
      const to = student_subject_menu_list.filter(l => l.is_hybrid)[0];
      navigate(`/parent/${to.student_id}/${convertToSlug(to.subject_name)}`);
    }
    store.set(
      haveParentSubjectMenu,
      student_subject_menu_list &&
        student_subject_menu_list.filter(l => l.is_hybrid).length > 0,
    );
  }, [student_subject_menu_list, isLoading]);

  const store = useStore();
  useEffect(() => {
    const uid = Cookies.get('uid');
    const is_login = Cookies.get('is_login');
    if (uid === undefined) {
      if (is_login === undefined) {
        setRenderParentPage(false);
      } else {
        setRenderParentPage(true);
      }
    } else {
      setRenderParentPage(true);
    }

    store.set(haveBottomNavbar, false);
    store.set(haveTopNavbar, false);
    store.set(haveTitle, false);
    store.set(haveFullLogo, false);
    store.set(haveBackButton, false);
    store.set(haveSubjectMenu, false);
    store.set(haveAccountSection, false);
    store.set(haveLogoutButton, true);

    return () => {
      resetToDefaultNavbarState();
    };
  }, []);

  return renderParentPage ? (
    <div className="parent_bg">
      <div className="parent_page_container">
        <NavBar
          showAccountDropdown={false}
          setShowAccountDropdown={() => {}}
          isShowMobileBubbleDropdown={false}
          setIsShowMobileBubbleDropdown={() => {}}
        />
        {!isLoading && <Outlet />}
      </div>
    </div>
  ) : null;
};

export default ParentPage;
